<template>
  <div
    class="h-full w-20 bg-v4-menu border-r border-slate-50 dark:border-slate-800/50 rtl:border-l rtl:border-r-0 flex justify-between flex-col"
  >
    <div class="flex flex-col items-center">
      <router-link :to="newHomeURL">
        <img
          src="../sidebarIcons/logo-menuv4.png"
          alt="icon"
          class="mt-6 mb-6 w-10 h-10 block dark:hidden"
        />
      </router-link>

      <router-link :to="newHomeURL">
        <img
          src="../sidebarIcons/logo-menuv4.png"
          alt="icon"
          class="mt-6 mb-6 w-8 h-8 hidden dark:block"
        />
      </router-link>

      <div @click="openMenu">
        <primary-nav-item
          v-for="menuItem in menuItems"
          :key="menuItem.toState"
          :icon="menuItem.icon"
          :name="menuItem.label"
          :to="menuItem.toState"
          :is-child-menu-active="menuItem.key === activeMenuItem"
        />
        <notification-bell @open-notification-panel="openNotificationPanel" />
      </div>
    </div>

    <div class="flex flex-col items-center justify-end pb-6">
      <help-bell @open-help-panel="openHelpPanel" />
      <primary-nav-item
        v-if="!isACustomBrandedInstance"
        icon="book-open-globe"
        name="DOCS"
        :open-in-new-page="true"
        :to="helpDocsURL"
      />
    </div>
  </div>
</template>
<script>
import Logo from './Logo.vue';
import PrimaryNavItem from './PrimaryNavItem.vue';
import OptionsMenu from './OptionsMenu.vue';
import AgentDetails from './AgentDetails.vue';
import NotificationBell from './NotificationBell.vue';
import HelpBell from './HelpBell.vue';
import wootConstants from 'dashboard/constants/globals';
import { frontendURL } from 'dashboard/helper/URLHelper';
import { ACCOUNT_EVENTS } from '../../../helper/AnalyticsHelper/events';
import { mapGetters } from 'vuex';
import accountMixin from '../../../mixins/account';

export default {
  components: {
    Logo,
    PrimaryNavItem,
    OptionsMenu,
    AgentDetails,
    NotificationBell,
    HelpBell,
  },
  props: {
    isACustomBrandedInstance: {
      type: Boolean,
      default: false,
    },
    logoSource: {
      type: String,
      default: '',
    },
    installationName: {
      type: String,
      default: '',
    },
    accountId: {
      type: Number,
      default: 0,
    },
    menuItems: {
      type: Array,
      default: () => [],
    },
    activeMenuItem: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      helpDocsURL: wootConstants.DOCS_URL,
      showOptionsMenu: false,
    };
  },
  methods: {
    frontendURL,
    toggleOptions() {
      this.showOptionsMenu = !this.showOptionsMenu;
    },
    toggleAccountModal() {
      this.$emit('toggle-accounts');
    },
    toggleSupportChatWindow() {
      window.$chatwoot.toggle();
    },
    openNotificationPanel() {
      this.$track(ACCOUNT_EVENTS.OPENED_NOTIFICATIONS);
      this.$emit('open-notification-panel');
    },
    openHelpPanel() {
      this.$emit('open-help-panel');
    },
    openMenu() {
      this.$emit('open-menu');
    },
  },
  mixins: [accountMixin],
  computed: {
    ...mapGetters({ globalConfig: 'globalConfig/get' }),
    newHomeURL() {
      return this.addAccountScoping('dashboard');
    },
  },
};
</script>

<style scoped>
  .bg-v4-menu{
    background: #EEEEEE
  }
</style>
